export const CLEARANCE_COLUMN = 'CLEARANCE_COLUMN';
export const CLEARANCE_INDEX = 'CLEARANCE_INDEX';
export const CLEARANCE_LOADING_INDEX = 'CLEARANCE_LOADING_INDEX';
export const CLEARANCE_RESET = 'CLEARANCE_RESET';
